import gql from 'graphql-tag';

export default gql`
  mutation deleteUser($userId: UUID!) {
    deleteUser(userId: $userId)
  }
`;
